import React, { Component } from 'react';
import { Card, Top, UserTable } from './_components';
import { WhiteSpace } from '@/components';
import { connect } from '@souche-f2e/muji';
const mapStateToProps = (rootState) => ({
    _state: rootState.groupMoneyManage,
});
class GroupMoneyManage extends Component {
    render() {
        const { totalMoney } = this.props._state;
        return (<>
          <Card money={totalMoney}/>
          <WhiteSpace h={23}/>
          <Top />
          <WhiteSpace h={37}/>
          <UserTable />
      </>);
    }
}
export default connect(mapStateToProps)(GroupMoneyManage);
